import { useState } from 'react';

export function PasswordField({
  value,
  onChange,
  creating = false,
}: {
  value: string;
  onChange: (value: string) => void;
  creating?: boolean;
}) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="field">
      <label htmlFor="password">Password</label>
      <div className="password-control">
        <input
          id="password"
          className="input"
          type={visible ? 'text' : 'password'}
          autoComplete={creating ? 'new-password' : 'current-password'}
          required
          minLength={creating ? 10 : undefined}
          maxLength={256}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          aria-describedby={creating ? 'password-hint' : undefined}
        />
        <button
          className="btn ghost sm"
          type="button"
          aria-label={visible ? 'Hide password' : 'Show password'}
          aria-pressed={visible}
          onClick={() => setVisible(!visible)}
        >
          {visible ? 'Hide' : 'Show'}
        </button>
      </div>
      {creating && (
        <span className="hint" id="password-hint">
          At least 10 characters. A few words in a row works well.
        </span>
      )}
    </div>
  );
}
